import React, { useEffect, useState } from "react";
import { CustomDiv } from "../../chat-bot/style";
import { Typography } from "@mui/material";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import Breadcrumbs from "../../../component/Breadcrumbs";
import { useLocation } from "react-router-dom";
import {
  GetInterviewkitData,
  UpdateInterviewkitData,
} from "../../../redux/action/Interview-kit";
import CommonButton from "../../../component/Button";
import EditInfoIco from "../../../assets/icons/EditInfoIco";
import QuestionMarkPinkIco from "../../../assets/icons/QuestionMarkPinkIco";
import SnackBar from "../../../component/SnackBar/index";
import { HandleSkeletion } from "../../../utils/constants";
import QuestionMarkIco from "../../../assets/icons/QuestionMarkIco";
import QuestionsSection from "./QuestionSection";
import { Dialog, DialogContent } from "@mui/material";
import CommonTextField from "../../../component/Input";

const InterviewKit = () => {
  const query = new URLSearchParams(useLocation().search);
  const jobTitle = query.get("title");
  const jobId = query.get("id");
  const queryValue = query.get("value");
  const matchId = query.get("match-id");
  const candidateName = query.get("candidate-name");
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [addQuestion, setAddQuestion] = useState({
    open: false,
    question: "",
    answer: "",
  });
  const [editData, setEditData] = useState(false);
  const breadCrumbData = [
    {
      title: "Jobs",
      navigate: "/jobs",
    },
    {
      title: jobTitle,
      navigate: `/jobs/jobs-view?id=${jobId}&title=${jobTitle}&value=${queryValue}&match-id=${matchId}`,
    },
    {
      title: "Assessment Test Transcipts",
      active: true,
    },
  ];
  const [interviewKitData, setInterviewKitData] = useState({
    data: {
      extracted: [],
      recommended: [],
      suggested: [],
    },
    loading: false,
    error: null,
  });
  const [originalData, setOriginalData] = useState(null);
  const [dirtyKeys, setDirtyKeys] = useState(new Set());
  const [saveLoading, setSaveLoading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    index: null,
    data: null,
    datatype: null,
  });

  useEffect(() => {
    setInterviewKitData((prev) => ({ ...prev, loading: true }));
    fetchInterviewKitData();
  }, [matchId]);

  const fetchInterviewKitData = async () => {
    try {
      const response = await GetInterviewkitData(matchId);
      setInterviewKitData((prev) => ({
        ...prev,
        data: response,
        loading: false,
      }));
      setOriginalData(JSON.parse(JSON.stringify(response)));
    } catch (error) {
      console.log(error);
      setInterviewKitData((prev) => ({
        ...prev,
        error: error,
        loading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        message: error.message,
        severity: "error",
      }));
    }
  };

  function handleAddQuestion() {
    if (addQuestion.question) {
      if (interviewKitData?.data?.suggested?.length >= 0) {
        const updatedData = [
          ...interviewKitData?.data?.suggested,
          {
            question: addQuestion.question,
            answer: addQuestion.answer,
            type: "suggested",
          },
        ];
        setInterviewKitData((prev) => ({
          ...prev,
          data: { ...prev.data, suggested: updatedData },
        }));
        setDirtyKeys((prev) => {
          const updated = new Set(prev);
          const key = `suggested-${updatedData.length - 1}`;
          updated.add(key);
          return updated;
        });
      }
    }
  }
  function handleAnswerChange(e, index, data, datatype, newData = false) {
    const newValue = e.target.value;
    data[index].answer = newValue;

    setInterviewKitData((prev) => ({
      ...prev,
      data: { ...prev.data, [datatype]: data },
    }));
    const originalValue = originalData[datatype]?.[index]?.answer;
    if (originalValue) {
      setDirtyKeys((prev) => {
        const updated = new Set(prev);
        const key = `${datatype}-${index}`;

        if (newValue === originalValue) {
          updated.delete(key);
        } else {
          updated.add(key);
        }
        return updated;
      });
    }
  }
  function handleDeleteQuestion(index, data, datatype) {
    const updatedData = data.filter((_, i) => i !== index);
    setInterviewKitData((prev) => ({
      ...prev,
      data: { ...prev.data, [datatype]: updatedData },
    }));
    setDirtyKeys((prev) => {
      const updated = new Set(prev);
      const key = `${datatype}-${index}`;
      if (updated.has(key)) {
        updated.delete(key);
      } else {
        updated.add(key);
      }
      return updated;
    });
  }

  async function handleSave() {
    try {
      setSaveLoading(true);
      const payload = transformQuestions(interviewKitData?.data);
      const response = await UpdateInterviewkitData(matchId, payload);
      setSnackbarState({
        open: true,
        message: response.message,
        severity: "success",
      });
      setSaveLoading(false);
      setDirtyKeys(new Set());
      fetchInterviewKitData();
      setEditData(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setSaveLoading(false);
      setDirtyKeys(new Set());
    }
  }

  function transformQuestions(input) {
    const { extracted, recommended, suggested } = input;
    console.log(
      extracted,
      recommended,
      suggested,
      "extracted, recommended, suggested"
    );
    const allQuestions = [...extracted, ...recommended, ...suggested];

    return { questions: allQuestions };
  }

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <CustomDiv
      height={"100vh"}
      background={"#F6F8FB"}
      display={"flex"}
      overflowY={"auto"}
    >
      <CommonGrid2
        width={"100%"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
      >
        <Breadcrumbs breadCrumbData={breadCrumbData} />
        <CommonGrid2
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          padding={"1rem 0px 0px 0px"}
        >
          <CustomDiv
            display={"flex"}
            width={"max-content"}
            alignItems={"center"}
            gap={"0rem"}
            justifyContent={"center"}
            customStyle={{
              flexDirection: "column",
            }}
          >
            <Typography variant="h3">
              {candidateName
                ? `${candidateName}'s Assessment Test Transcipts`
                : "Assessment Test Transcipts"}
            </Typography>
            <Typography variant="subtitle2" fontWeight={500} color={"#475467"}>
              {jobTitle || ""}
            </Typography>
          </CustomDiv>
          <CommonGrid2 display={"flex"} gap={"1rem"}>
            <CommonButton
              value={editData ? (saveLoading ? "Saving..." : "Save") : "Edit"}
              variant={editData ? "contained" : "outlined"}
              startIcon={!editData && <EditInfoIco />}
              color={editData ? "primary" : "#344054"}
              padding={"8px 16px"}
              fontWeight={600}
              fontSize={"14px"}
              gap={"0px"}
              disabled={editData && (saveLoading || dirtyKeys.size === 0)}
              onClick={() => {
                if (editData) {
                  handleSave();
                } else setEditData((prev) => !prev);
              }}
              loading={saveLoading}
              svg={true}
            />
            {(editData || saveLoading) && (
              <CommonButton
                value="Cancel"
                variant="outlined"
                padding={"8px 16px"}
                color={"#344054"}
                fontWeight={600}
                fontSize={"14px"}
                gap={"0px"}
                onClick={() => {
                  setEditData(false);
                  setInterviewKitData((prev) => ({
                    ...prev,
                    data: originalData,
                  }));
                  setDirtyKeys(new Set());
                }}
                disabled={saveLoading}
              />
            )}
          </CommonGrid2>
        </CommonGrid2>
        {interviewKitData?.loading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <HandleSkeletion
              key={index}
              height="50px"
              width="100%"
              marginBottom="1rem"
            />
          ))
        ) : (
          <>
            <QuestionsSection
              title="Questions from Job Description"
              icon={<QuestionMarkPinkIco />}
              data={interviewKitData?.data?.extracted}
              handleAnswerChange={handleAnswerChange}
              loading={interviewKitData?.loading}
              addQuestion={addQuestion}
              setAddQuestion={setAddQuestion}
              handleDeleteQuestion={handleDeleteQuestion}
              editable={editData}
              datatype="extracted"
              isSuggested={false}
              setDeleteConfirm={setDeleteConfirm}
            />
            {interviewKitData?.data?.recommended?.length !== 0 && (
              <QuestionsSection
                title="Recommended Questions"
                icon={<QuestionMarkIco />}
                data={interviewKitData?.data?.recommended}
                handleAnswerChange={handleAnswerChange}
                loading={interviewKitData?.loading}
                addQuestion={addQuestion}
                setAddQuestion={setAddQuestion}
                handleDeleteQuestion={handleDeleteQuestion}
                editable={editData}
                datatype="recommended"
                isSuggested={false}
                setDeleteConfirm={setDeleteConfirm}
              />
            )}
            <QuestionsSection
              title="Live Screening Questions"
              icon={<QuestionMarkIco />}
              data={interviewKitData?.data?.suggested}
              handleAnswerChange={handleAnswerChange}
              loading={interviewKitData?.loading}
              addQuestion={addQuestion}
              setAddQuestion={setAddQuestion}
              editable={editData}
              handleDeleteQuestion={handleDeleteQuestion}
              datatype="suggested"
              isSuggested={true}
              setDeleteConfirm={setDeleteConfirm}
            />
          </>
        )}
      </CommonGrid2>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <Dialog
        open={addQuestion.open}
        onClose={() => setAddQuestion((prev) => ({ ...prev, open: false }))}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogContent
          sx={{
            padding: "1.5rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography variant="h3">Add Question</Typography>
          <CommonTextField
            label={"Question"}
            fontSize={"14px"}
            padding={"10px"}
            labelShrink={"10px"}
            value={addQuestion.question}
            onChange={(e) =>
              setAddQuestion((prev) => ({ ...prev, question: e.target.value }))
            }
          />
          <CommonTextField
            label={"Answer"}
            fontSize={"14px"}
            padding={"10px"}
            height={"50px"}
            multiline={true}
            customStyle={{
              "& .MuiInputBase-input": {
                height: "50px",
              },
            }}
            value={addQuestion.answer}
            onChange={(e) =>
              setAddQuestion((prev) => ({ ...prev, answer: e.target.value }))
            }
          />
          <CommonButton
            value={"Add"}
            padding={"10px"}
            fontSize={"14px"}
            fontWeight={600}
            disabled={!addQuestion.question}
            onClick={() => {
              handleAddQuestion();
              setAddQuestion((prev) => ({
                ...prev,
                open: false,
                question: "",
                answer: "",
              }));
            }}
          />
          <CommonButton
            value={"Cancel"}
            padding={"10px"}
            fontSize={"14px"}
            fontWeight={600}
            onClick={() => setAddQuestion((prev) => ({ ...prev, open: false }))}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={deleteConfirm.open}
        onClose={() => setDeleteConfirm({ open: false, index: null })}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogContent
          sx={{
            padding: "1.5rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography variant="h3">Delete Question?</Typography>
          <Typography variant="body2">
            Are you sure you want to delete this question?
          </Typography>
          <CommonGrid2 display="flex" gap="0.5rem" justifyContent="flex-end">
            <CommonButton
              value={"Cancel"}
              padding={"8px 16px"}
              fontSize={"14px"}
              fontWeight={600}
              variant="outlined"
              onClick={() => setDeleteConfirm({ open: false, index: null })}
            />
            <CommonButton
              value={"Delete"}
              padding={"8px 16px"}
              fontSize={"14px"}
              fontWeight={600}
              background="#D80027"
              onClick={() => {
                handleDeleteQuestion(
                  deleteConfirm?.index,
                  deleteConfirm?.data,
                  deleteConfirm?.datatype
                );
                setDeleteConfirm({
                  open: false,
                  index: null,
                  data: null,
                  datatype: null,
                });
              }}
            />
          </CommonGrid2>
        </DialogContent>
      </Dialog>
    </CustomDiv>
  );
};

export default InterviewKit;
